import React, { useState } from 'react'
import styled from 'styled-components'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import {
  CartBtnLeft,
  CartBtnRight,
  CartBtnWrap,
  ModalBody,
  ModalBox,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalWrap,
} from '../product/ProductModal'
import { imgURL } from '../Footer'
import { ModalBackground } from './MarketingGiveUpModal'
import { postUserNotiSetting } from '../../api/login'
import { useMyContext } from '../provider/MyProvider'
import { getFormattedDate } from '../../js/script'

interface PropsType {
  setMarketingModal: React.Dispatch<React.SetStateAction<boolean>>
}

/**
 * 모달 팝업 - 아래 꽉참
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

export default function MarketingModal({ setMarketingModal }: PropsType) {
  const { setToastMessage, setIsToast } = useMyContext()
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      setMarketingModal(false)
      setClosing(false)
    }, 280)
  }

  const handleKeep = async (e: React.MouseEvent) => {
    e.preventDefault() // 이벤트 기본 동작 방지

    try {
      setIsToast(true)
      setToastMessage(`마케팅 알림 수신 ${getFormattedDate()} 에 동의 완료 처리 되었습니다.`)
      await postUserNotiSetting(true)
      window.sessionStorage.setItem('welcomeGiveup', JSON.stringify(true))
      closeModal()
    } catch (err) {
      console.error(err)
    }
  }

  const handleGiveUp = async (e: React.MouseEvent) => {
    e.preventDefault() // 이벤트 기본 동작 방지

    try {
      setIsToast(true)
      setToastMessage(`마케팅 알림 수신 ${getFormattedDate()} 에 동의 거부 처리 되었습니다.`)
      await postUserNotiSetting(false)
      closeModal()
      window.sessionStorage.setItem('welcomeGiveup', JSON.stringify(true))
    } catch (err) {
      console.error(err)
    }
  }

  // if (!isModal) return null;
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <ModalTitle>마케팅 알림 수신 동의</ModalTitle>
          <button className='btn_close' onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt='닫기' />
          </button>
        </ModalHeader>
        <ModalBody
          style={{ display: 'flex', gap: '12px', flexDirection: 'column', marginTop: '18.5px', marginBottom: '18px' }}
        >
          <ModalBodyContent>각종 챌린지와 이벤트, 쇼핑 등 유용한 전용 혜택 정보를 제공해드립니다. </ModalBodyContent>
          <ModalBodyContent>
            수신동의 기간{' '}
            <span style={{ color: '#0041FF' }}>5일 마다 적립금 1,000원, 매월말 쇼핑 쿠폰을 발급 드립니다.</span>
          </ModalBodyContent>
          <ModalBodyContent>※ 수신동의는 마이피싱 알림설정에서 언제든지 변경할 수 있습니다.</ModalBodyContent>
        </ModalBody>

        <div>
          <ModalFooter className='footer'>
            <CartBtnWrap>
              <CartBtnLeft
                style={{ backgroundColor: '#F3F3F3', borderRadius: '25px', fontSize: '16px', lineHeight: '20px' }}
                onClick={handleGiveUp}
              >
                동의안함
              </CartBtnLeft>
              <CartBtnRight style={{ borderRadius: '25px', fontSize: '16px', lineHeight: '20px' }} onClick={handleKeep}>
                동의함
              </CartBtnRight>
            </CartBtnWrap>
          </ModalFooter>
        </div>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  )
}

const ModalBodyContent = styled.p`
  font-size: 15px;
  line-height: 17px;
  color: #363636;
  font-weight: 400;
`
